import { useEffect, useRef, useState } from "react";
import useReveal from "@/hooks/useReveal";

const VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_afrqa-luxury/artifacts/9pomtfmn_Black_female_model_turns_head_202605122229.mov";
const POSTER =
  "https://customer-assets.emergentagent.com/job_afrqa-luxury/artifacts/0d8djkx6_afrqa%20model.PNG";

export default function CinematicVideo() {
  const videoRef = useRef(null);
  const overlay = useReveal();
  const [videoOk, setVideoOk] = useState(true);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const tryPlay = async () => {
      try {
        await v.play();
      } catch {
        /* autoplay may fail silently; poster remains */
      }
    };
    tryPlay();
  }, []);

  return (
    <section
      id="cinematic"
      data-testid="cinematic-video-section"
      className="relative w-full h-[88svh] min-h-[560px] overflow-hidden bg-black"
    >
      {videoOk ? (
        <video
          ref={videoRef}
          className="absolute inset-0 w-full h-full object-cover"
          src={VIDEO_URL}
          poster={POSTER}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          onError={() => setVideoOk(false)}
          data-testid="cinematic-video"
        />
      ) : (
        <img
          src={POSTER}
          alt="The Africa Frame — cinematic"
          className="absolute inset-0 w-full h-full object-cover hero-image"
        />
      )}

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/70" />
      <div className="grain-overlay" />
      <div className="vignette" />

      <div className="relative z-10 h-full max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col items-center justify-center text-center">
        <div
          ref={overlay.ref}
          className={`reveal ${overlay.inView ? "in-view" : ""}`}
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-10 h-px bg-[#d4af37]" />
            <span className="font-label text-[#d4af37]">The Film</span>
            <div className="w-10 h-px bg-[#d4af37]" />
          </div>
          <h2
            className="font-editorial italic text-white text-[clamp(2.2rem,6vw,5.2rem)] leading-[1.04] tracking-tight max-w-4xl"
            data-testid="cinematic-overlay-text"
          >
            See the world through{" "}
            <span className="gold-text-gradient not-italic font-display">
              heritage.
            </span>
          </h2>
          <p className="mt-6 font-label text-[#9a9a93]">
            Editorial Campaign · Vol. I
          </p>
        </div>
      </div>
    </section>
  );
}
